import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  selected_for_report: null,
  qr_scaning: false,
  qr_serial: null,
  qr_product: null,
}

export const getters = {
  selected_for_report: (state) => state.selected_for_report,
  qr_scaning: (state) => state.qr_scaning,
  qr_serial: (state) => state.qr_serial,
  qr_product: (state) => state.qr_product,
}

export const mutations = {
  SET_SELECTED_FOR_REPORT(state, product) {
    state.selected_for_report = product
  },
  SET_QR_SCANING(state, status) {
    state.qr_scaning = status
  },
  SET_QR_SERIAL(state, serial) {
    state.qr_serial = serial
  },
  SET_QR_PRODUCT(state, product) {
    state.qr_product = product
  }
}

export const actions = {

  init({ state, dispatch }) {},

  selectProduct({ commit }, product) {
    commit('SET_SELECTED_FOR_REPORT', product)
  },

  fetchProductsToList(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/products/tolist/${query}`).then((response) => {
      const results = response.data
      return results
    })
  },
  fetchProducts(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/products/${query}`).then((response) => {
      // const results = response.data
      const results = response
      return results
    })
  },
  fetchProductsReport(context, query) {
    return axios.get(`${serverUrl}/APIv1/products/${query}`, { responseType: 'arraybuffer' }).then((response) => {
      return response
    })
  },
  enableQrScaning( { commit }) {
    commit('SET_QR_SCANING', true)
  },
  disableQrScaning( { commit }) {
    commit('SET_QR_SCANING', false)
  },
  setQrSerial( { commit }, serial) {
    commit('SET_QR_SERIAL', serial)
  },
  setQrProduct({ commit }, product) {
    commit('SET_QR_PRODUCT', product)
  }
  
}